import { DEFAULT_CHART_WIDTH, DEFAULT_CHART_HEIGHT } from "../../../constant/base";

import { DEFAULT_OPTIONS } from "./constants";

import { isTrueBrowser } from "../../../util/env";

import { getScale } from "./utils/common";

import { getActualTooltipPositionValue, getCartesianCrosshairRect, getHorizontalPositionType, getVerticalPositionType, isFixedTooltipPositionPattern, isGlobalTooltipPositionPattern } from "./utils/position";

import { isNumber, isObject, isValidNumber, isValid, throttle, isNil, polygonContainPoint, pointInRect, isFunction } from "@visactor/vutils";

import { getTooltipAttributes } from "./utils/attribute";

import { BasePlugin } from "../../base/base-plugin";

import { getFirstSeries } from "../../../util";

import { getTooltipPatternValue } from "../../../component/tooltip/utils";

export class BaseTooltipHandler extends BasePlugin {
    constructor() {
        super(...arguments), this._visible = !0, this._attributes = null, this._isReleased = !1, 
        this.showTooltip = (activeType, data, params) => {
            const {changePositionOnly: changePositionOnly} = params;
            return changePositionOnly ? this.changeTooltipPosition(params, data) : this.changeTooltip(!0, params, data);
        }, this._changeTooltip = (visible, params, data) => this._isReleased ? 1 : visible ? this._changeTooltipPosition(params, data) : (this._clearAllCache(), 
        this._updateTooltip(!1, params), 0), this._changeTooltipPosition = (params, data) => {
            var _a, _b, _c;
            if (this._isReleased) return 1;
            const event = params.event, {tooltipSpec: tooltipSpec, tooltipActual: tooltipActual, changePositionOnly: changePositionOnly} = params;
            if (tooltipSpec.enterable) {
                if (!this._isPointerEscaped && this._isPointerMovingToTooltip(params)) return this._isTooltipPaused || (this._isTooltipPaused = !0, 
                this._cachePointerTimer = setTimeout((() => {
                    this._isPointerEscaped = !0;
                }), 300)), 0;
                this._isTooltipPaused = !1, this._isPointerEscaped = !1, clearTimeout(this._cachePointerTimer), 
                this._cachePointerPosition = this._getPointerPositionRelativeToTooltipParent(params);
            }
            const activeType = tooltipActual.activeType;
            if (tooltipSpec.handler) return null !== (_c = null === (_b = (_a = tooltipSpec.handler).showTooltip) || void 0 === _b ? void 0 : _b.call(_a, activeType, data, params)) && void 0 !== _c ? _c : 0;
            const pattern = tooltipSpec[activeType];
            if (!pattern) return 1;
            const position = this._getActualTooltipPosition(tooltipActual, params, this._getTooltipBoxSize(tooltipActual, changePositionOnly));
            tooltipActual.position = position, pattern.updatePosition && (tooltipActual.position = pattern.updatePosition(tooltipActual.position, data, params));
            let tooltipVisible = !1 !== (null == pattern ? void 0 : pattern.visible);
            return data && "pointerout" !== event.type && tooltipActual.visible && (tooltipActual.title || tooltipActual.content) || (tooltipVisible = !1), 
            this._updateTooltip(tooltipVisible, Object.assign(Object.assign({}, params), {
                changePositionOnly: changePositionOnly
            })), 0;
        }, this._getActualTooltipPosition = (actualTooltip, params, tooltipBoxSize) => {
            var _a, _b, _c, _d, _e, _f, _g;
            const event = params.event, {tooltipSpec: tooltipSpec} = params, firstDimensionInfo = null === (_a = params.dimensionInfo) || void 0 === _a ? void 0 : _a[0], invalidPosition = {
                x: 1 / 0,
                y: 1 / 0
            };
            let {offsetX: offsetX, offsetY: offsetY} = this._option;
            if (!tooltipSpec) return this._cacheTooltipPosition = void 0, invalidPosition;
            const {activeType: activeType, data: data} = actualTooltip, pattern = tooltipSpec[activeType], position = getTooltipPatternValue(pattern.position, data, params), positionMode = null !== (_b = getTooltipPatternValue(pattern.positionMode, data, params)) && void 0 !== _b ? _b : "mark" === activeType ? "mark" : "pointer", tooltipParentElement = this._getParentElement(tooltipSpec), {width: tooltipBoxWidth = 0, height: tooltipBoxHeight = 0} = null != tooltipBoxSize ? tooltipBoxSize : {}, isCanvas = "canvas" === tooltipSpec.renderMode, canvasRect = null === (_c = null == params ? void 0 : params.chart) || void 0 === _c ? void 0 : _c.getCanvasRect(), canvasWidth = null !== (_d = null == canvasRect ? void 0 : canvasRect.width) && void 0 !== _d ? _d : DEFAULT_CHART_WIDTH, canvasHeight = null !== (_e = null == canvasRect ? void 0 : canvasRect.height) && void 0 !== _e ? _e : DEFAULT_CHART_HEIGHT;
            let isFixedPosition = !1;
            const containerSize = {
                width: 0,
                height: 0
            };
            let relativePosOffset = {
                x: 0,
                y: 0
            }, tooltipParentElementRect = {
                x: 0,
                y: 0
            }, chartElementScale = 1, tooltipParentElementScale = 1;
            if (isTrueBrowser(this._env) && !tooltipSpec.confine) {
                if (containerSize.width = window.innerWidth, containerSize.height = window.innerHeight, 
                !isCanvas) {
                    tooltipParentElementRect = null !== (_f = null == tooltipParentElement ? void 0 : tooltipParentElement.getBoundingClientRect()) && void 0 !== _f ? _f : invalidPosition;
                    const chartElement = null !== (_g = this._compiler.getCanvas()) && void 0 !== _g ? _g : this._chartContainer, chartElementRect = null == chartElement ? void 0 : chartElement.getBoundingClientRect();
                    relativePosOffset = {
                        x: chartElementRect.x - tooltipParentElementRect.x,
                        y: chartElementRect.y - tooltipParentElementRect.y
                    }, chartElementScale = getScale(chartElement, chartElementRect), tooltipParentElementScale = getScale(tooltipParentElement, tooltipParentElementRect);
                }
            } else containerSize.width = canvasWidth, containerSize.height = canvasHeight;
            const tooltipSizeScale = tooltipParentElementScale / chartElementScale;
            let left, top, right, bottom, pointerFixedPositionX = position, pointerFixedPositionY = position;
            const processCartesianFixedPositionX = ({orient: orient, mode: mode, offset: offset}) => {
                var _a;
                let x1, x2;
                const model = params.model, startPoint = null == model ? void 0 : model.getLayoutStartPoint();
                if (offsetX = null != offset ? offset : offsetX, "mark" === mode) {
                    isFixedPosition = !0;
                    const element = params.item, bounds = null == element ? void 0 : element.getBounds();
                    bounds && startPoint && (x1 = bounds.x1 + startPoint.x, x2 = bounds.x2 + startPoint.x);
                } else if ("crosshair" === mode && "cartesian" === (null === (_a = null == firstDimensionInfo ? void 0 : firstDimensionInfo.axis) || void 0 === _a ? void 0 : _a.getCoordinateType())) {
                    isFixedPosition = !0;
                    const rect = getCartesianCrosshairRect(params.dimensionInfo, getFirstSeries(this._component.getRegions(), "cartesian"), startPoint);
                    rect && (x1 = rect.start.x, x2 = rect.end.x);
                } else pointerFixedPositionX = orient;
                if (isFixedPosition) switch (getHorizontalPositionType(orient)) {
                  case "left":
                    left = x1 - tooltipBoxWidth * tooltipSizeScale - offsetX;
                    break;

                  case "right":
                    left = x2 + offsetX;
                    break;

                  case "center":
                    left = (x1 + x2) / 2 - tooltipBoxWidth * tooltipSizeScale / 2;
                    break;

                  case "centerLeft":
                    left = (x1 + x2) / 2 - tooltipBoxWidth * tooltipSizeScale - offsetX;
                    break;

                  case "centerRight":
                    left = (x1 + x2) / 2 + offsetX;
                }
            }, processCartesianFixedPositionY = ({orient: orient, mode: mode, offset: offset}) => {
                var _a;
                let y1, y2;
                const model = params.model, startPoint = null == model ? void 0 : model.getLayoutStartPoint();
                if (offsetY = null != offset ? offset : offsetY, "mark" === mode) {
                    isFixedPosition = !0;
                    const element = params.item, bounds = null == element ? void 0 : element.getBounds();
                    bounds && startPoint && (y1 = bounds.y1 + startPoint.y, y2 = bounds.y2 + startPoint.y);
                } else if ("crosshair" === mode && "cartesian" === (null === (_a = null == firstDimensionInfo ? void 0 : firstDimensionInfo.axis) || void 0 === _a ? void 0 : _a.getCoordinateType())) {
                    isFixedPosition = !0;
                    const rect = getCartesianCrosshairRect(params.dimensionInfo, getFirstSeries(this._component.getRegions(), "cartesian"), startPoint);
                    rect && (y1 = rect.start.y, y2 = rect.end.y);
                } else pointerFixedPositionY = orient;
                if (isFixedPosition) switch (getVerticalPositionType(orient)) {
                  case "top":
                    top = y1 - tooltipBoxHeight * tooltipSizeScale - offsetY;
                    break;

                  case "bottom":
                    top = y2 + offsetY;
                    break;

                  case "center":
                    top = (y1 + y2) / 2 - tooltipBoxHeight * tooltipSizeScale / 2;
                    break;

                  case "centerTop":
                    top = (y1 + y2) / 2 - tooltipBoxHeight * tooltipSizeScale - offsetY;
                    break;

                  case "centerBottom":
                    top = (y1 + y2) / 2 + offsetY;
                }
            };
            if (isObject(position)) {
                if (isGlobalTooltipPositionPattern(position)) {
                    const {left: posLeft, right: posRight, top: posTop, bottom: posBottom} = position;
                    left = getActualTooltipPositionValue(posLeft, event), top = getActualTooltipPositionValue(posTop, event), 
                    right = getActualTooltipPositionValue(posRight, event), bottom = getActualTooltipPositionValue(posBottom, event);
                } else if (isFixedTooltipPositionPattern(position)) {
                    const {x: x, y: y} = position;
                    isNumber(x) || isFunction(x) ? left = getActualTooltipPositionValue(x, event) : processCartesianFixedPositionX(x), 
                    isNumber(y) || isFunction(y) ? top = getActualTooltipPositionValue(y, event) : processCartesianFixedPositionY(y);
                }
            } else isValid(position) && (processCartesianFixedPositionX({
                orient: position,
                mode: positionMode
            }), processCartesianFixedPositionY({
                orient: position,
                mode: positionMode
            }));
            let x, y;
            const {canvasX: canvasX, canvasY: canvasY} = event;
            if (isValidNumber(left)) x = left; else if (isValidNumber(right)) x = canvasWidth - tooltipBoxWidth * tooltipSizeScale - right; else {
                const x0 = canvasX;
                switch (getHorizontalPositionType(pointerFixedPositionX, "right")) {
                  case "center":
                    x = x0 - tooltipBoxWidth * tooltipSizeScale / 2;
                    break;

                  case "left":
                  case "centerLeft":
                    x = x0 - tooltipBoxWidth * tooltipSizeScale - offsetX;
                    break;

                  case "right":
                  case "centerRight":
                    x = x0 + offsetX;
                }
            }
            if (isValidNumber(top)) y = top; else if (isValidNumber(bottom)) y = canvasHeight - tooltipBoxHeight * tooltipSizeScale - bottom; else {
                const y0 = canvasY;
                switch (getVerticalPositionType(pointerFixedPositionY, "bottom")) {
                  case "center":
                    y = y0 - tooltipBoxHeight * tooltipSizeScale / 2;
                    break;

                  case "top":
                  case "centerTop":
                    y = y0 - tooltipBoxHeight * tooltipSizeScale - offsetY;
                    break;

                  case "bottom":
                  case "centerBottom":
                    y = y0 + offsetY;
                }
            }
            x *= chartElementScale, y *= chartElementScale, isTrueBrowser(this._env) && (x += relativePosOffset.x, 
            y += relativePosOffset.y), x /= tooltipParentElementScale, y /= tooltipParentElementScale;
            const {width: containerWidth, height: containerHeight} = containerSize, isLeftOut = () => x * tooltipParentElementScale + tooltipParentElementRect.x < 0, isRightOut = () => (x + tooltipBoxWidth) * tooltipParentElementScale + tooltipParentElementRect.x > containerWidth, isTopOut = () => y * tooltipParentElementScale + tooltipParentElementRect.y < 0, isBottomOut = () => (y + tooltipBoxHeight) * tooltipParentElementScale + tooltipParentElementRect.y > containerHeight, detectLeftFirst = () => {
                isLeftOut() && (isFixedPosition ? x = -tooltipParentElementRect.x / tooltipParentElementScale : "center" === getHorizontalPositionType(position, "right") ? x += offsetX + tooltipBoxWidth / 2 : x += 2 * offsetX + tooltipBoxWidth);
            }, detectLeftLast = () => {
                isLeftOut() && (x = -tooltipParentElementRect.x / tooltipParentElementScale);
            }, detectRightFirst = () => {
                isRightOut() && (isFixedPosition ? x = (containerWidth - tooltipParentElementRect.x) / tooltipParentElementScale - tooltipBoxWidth : "center" === getHorizontalPositionType(position, "right") ? x -= offsetX + tooltipBoxWidth / 2 : x -= 2 * offsetX + tooltipBoxWidth);
            }, detectRightLast = () => {
                isRightOut() && (x = (containerWidth - tooltipParentElementRect.x) / tooltipParentElementScale - tooltipBoxWidth);
            }, detectTopFirst = () => {
                isTopOut() && (isFixedPosition ? y = -tooltipParentElementRect.y / tooltipParentElementScale : "center" === getVerticalPositionType(position, "bottom") ? y += offsetY + tooltipBoxHeight / 2 : y += 2 * offsetY + tooltipBoxHeight);
            }, detectTopLast = () => {
                isTopOut() && (y = 0 - tooltipParentElementRect.y / tooltipParentElementScale);
            }, detectBottomFirst = () => {
                isBottomOut() && (isFixedPosition ? y = (containerHeight - tooltipParentElementRect.y) / tooltipParentElementScale - tooltipBoxHeight : "center" === getVerticalPositionType(position, "bottom") ? y -= offsetY + tooltipBoxHeight / 2 : y -= 2 * offsetY + tooltipBoxHeight);
            }, detectBottomLast = () => {
                isBottomOut() && (y = (containerHeight - tooltipParentElementRect.y) / tooltipParentElementScale - tooltipBoxHeight);
            };
            switch (getHorizontalPositionType(position, "right")) {
              case "center":
              case "centerLeft":
              case "centerRight":
                isLeftOut() ? (detectLeftFirst(), detectRightLast()) : (detectRightFirst(), detectLeftLast());
                break;

              case "left":
                detectLeftFirst(), detectRightLast();
                break;

              case "right":
                detectRightFirst(), detectLeftLast();
            }
            switch (getVerticalPositionType(position, "bottom")) {
              case "center":
              case "centerTop":
              case "centerBottom":
                isTopOut() ? (detectTopFirst(), detectBottomLast()) : (detectBottomFirst(), detectTopLast());
                break;

              case "top":
                detectTopFirst(), detectBottomLast();
                break;

              case "bottom":
                detectBottomFirst(), detectTopLast();
            }
            const result = {
                x: x,
                y: y
            };
            return this._cacheTooltipPosition = result, this._cacheTooltipSize = {
                width: tooltipBoxWidth,
                height: tooltipBoxHeight
            }, result;
        };
    }
    get env() {
        return this._env;
    }
    onAdd(service) {
        super.onAdd(service);
        const component = service.component;
        this._component = component, this._chartOption = component.getOption(), this._env = this._chartOption.mode, 
        this._chartContainer = this._chartOption.globalInstance.getContainer(), this._compiler = component.getCompiler(), 
        this._initFromSpec();
    }
    hideTooltip(params) {
        return this.changeTooltip(!1, params);
    }
    release() {
        var _a, _b, _c;
        this._clearAllCache();
        const spec = null !== (_a = this._component.getSpec()) && void 0 !== _a ? _a : {};
        spec.handler ? null === (_c = (_b = spec.handler).release) || void 0 === _c || _c.call(_b) : (this._removeTooltip(), 
        this._isReleased = !0);
    }
    _clearAllCache() {
        this._isTooltipPaused = !1, this._isPointerEscaped = !1, clearTimeout(this._cachePointerTimer), 
        this._cachePointerTimer = -1, this._cachePointerPosition = void 0, this._cacheTooltipPosition = void 0, 
        this._cacheTooltipSize = void 0;
    }
    _throttle(callback) {
        const tooltipSpec = this._component.getSpec();
        let wait;
        return wait = isNumber(tooltipSpec.throttleInterval) ? tooltipSpec.throttleInterval : "html" === tooltipSpec.renderMode && tooltipSpec.transitionDuration ? 50 : 10, 
        throttle(callback, wait);
    }
    _getDefaultOption() {
        var _a, _b;
        const {offset: offset} = this._component.getSpec();
        return Object.assign(Object.assign({}, DEFAULT_OPTIONS), {
            offsetX: null !== (_a = null == offset ? void 0 : offset.x) && void 0 !== _a ? _a : DEFAULT_OPTIONS.offsetX,
            offsetY: null !== (_b = null == offset ? void 0 : offset.y) && void 0 !== _b ? _b : DEFAULT_OPTIONS.offsetY
        });
    }
    _getTooltipBoxSize(actualTooltip, changePositionOnly) {
        var _a, _b, _c;
        if (!changePositionOnly || isNil(this._attributes)) {
            const chartTheme = null !== (_b = null === (_a = this._chartOption) || void 0 === _a ? void 0 : _a.getTheme()) && void 0 !== _b ? _b : {};
            this._attributes = getTooltipAttributes(actualTooltip, this._component.getSpec(), chartTheme);
        }
        const {panel: panel, panelDomHeight: panelDomHeight} = null !== (_c = this._attributes) && void 0 !== _c ? _c : {}, isCanvas = "canvas" === this._component.getSpec().renderMode;
        return {
            width: (null == panel ? void 0 : panel.width) + (isCanvas ? panel.lineWidth : 0),
            height: (null != panelDomHeight ? panelDomHeight : null == panel ? void 0 : panel.height) + (isCanvas ? panel.lineWidth : 0)
        };
    }
    _getPointerPositionRelativeToTooltipParent(params) {
        var _a, _b;
        let {canvasX: x, canvasY: y} = params.event;
        const {tooltipSpec: tooltipSpec} = params, invalidPosition = {
            x: 1 / 0,
            y: 1 / 0
        }, isCanvas = "canvas" === tooltipSpec.renderMode, tooltipParentElement = this._getParentElement(tooltipSpec);
        let relativePosOffset = {
            x: 0,
            y: 0
        }, tooltipParentElementRect = {
            x: 0,
            y: 0
        }, chartElementScale = 1, tooltipParentElementScale = 1;
        if (isTrueBrowser(this._env) && !tooltipSpec.confine && !isCanvas) {
            tooltipParentElementRect = null !== (_a = null == tooltipParentElement ? void 0 : tooltipParentElement.getBoundingClientRect()) && void 0 !== _a ? _a : invalidPosition;
            const chartElement = null !== (_b = this._compiler.getCanvas()) && void 0 !== _b ? _b : this._chartContainer, chartElementRect = null == chartElement ? void 0 : chartElement.getBoundingClientRect();
            relativePosOffset = {
                x: chartElementRect.x - tooltipParentElementRect.x,
                y: chartElementRect.y - tooltipParentElementRect.y
            }, chartElementScale = getScale(chartElement, chartElementRect), tooltipParentElementScale = getScale(tooltipParentElement, tooltipParentElementRect);
        }
        return x *= chartElementScale, y *= chartElementScale, isTrueBrowser(this._env) && (x += relativePosOffset.x, 
        y += relativePosOffset.y), x /= tooltipParentElementScale, y /= tooltipParentElementScale, 
        {
            x: x,
            y: y
        };
    }
    _isPointerMovingToTooltip(params) {
        if (!this._cacheTooltipPosition || !this._cacheTooltipSize || !this._cachePointerPosition) return !1;
        const {width: tooltipWidth, height: tooltipHeight} = this._cacheTooltipSize, {x: tooltipX = 0, y: tooltipY} = this._cacheTooltipPosition, pos = this._getPointerPositionRelativeToTooltipParent(params);
        if (pointInRect(pos, {
            x1: tooltipX,
            y1: tooltipY,
            x2: tooltipX + tooltipWidth,
            y2: tooltipY + tooltipHeight
        }, !1)) return !0;
        const a = {
            x: tooltipX,
            y: tooltipY
        }, b = {
            x: a.x + tooltipWidth,
            y: a.y
        }, c = {
            x: a.x,
            y: a.y + tooltipHeight
        }, d = {
            x: b.x,
            y: c.y
        }, oldPos = this._cachePointerPosition;
        return polygonContainPoint([ oldPos, a, b ], pos.x, pos.y) || polygonContainPoint([ oldPos, c, d ], pos.x, pos.y) || polygonContainPoint([ oldPos, a, d ], pos.x, pos.y) || polygonContainPoint([ oldPos, b, c ], pos.x, pos.y);
    }
    _getParentElement(spec) {
        return spec.parentElement;
    }
    getTooltipContainer() {
        return this._container;
    }
    _initFromSpec() {
        this._option = this._getDefaultOption(), this.changeTooltip = this._throttle(this._changeTooltip), 
        this.changeTooltipPosition = this._throttle(this._changeTooltipPosition);
    }
    reInit() {
        this._initFromSpec();
    }
}

BaseTooltipHandler.specKey = "tooltip";
//# sourceMappingURL=base.js.map
